export const GET_FLOWS = 'GET_FLOWS';
export const GET_FLOWS_SUCCESS = 'GET_FLOWS_SUCCESS';
export const GET_FLOWS_FAILURE = 'GET_FLOWS_FAILURE';

export const GET_CUSTOMER_PAIR_INFO = 'GET_CUSTOMER_PAIR_INFO';
export const GET_CUSTOMER_PAIR_INFO_SUCCESS = 'GET_CUSTOMER_PAIR_INFO_SUCCESS';
export const GET_CUSTOMER_PAIR_INFO_FAILURE = 'GET_CUSTOMER_PAIR_INFO_FAILURE';

export const SUBSCRIBE_TO_LINKED_CP_INFO_UPDATE_SUCCESS = 'SUBSCRIBE_TO_LINKED_CP_INFO_UPDATE_SUCCESS';

export const SUBSCRIBE_TO_FLOWS_UPDATE_SUCCESS = 'SUBSCRIBE_TO_FLOWS_UPDATE_SUCCESS';

export const ADD_FLOW = 'ADD_FLOW';
export const ADD_FLOW_SUCCESS = 'ADD_FLOW_SUCCESS';
export const ADD_FLOW_FAILURE = 'ADD_FLOW_FAILURE';

export const DELETE_FLOW = 'DELETE_FLOW';
export const DELETE_FLOW_SUCCESS = 'DELETE_FLOW_SUCCESS';
export const DELETE_FLOW_FAILURE = 'DELETE_FLOW_FAILURE';

export const CLEAR_SHARED_DATA = 'CLEAR_SHARED_DATA';
